<template>
  <div class="p-2">
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="d-inline-block mb-0">
              {{ $t('Commissions') }}
            </h5>
            <b-button v-permission="'change_receipt'" class="float-right p-0" variant="link" @click="onTermsEditClick">
              <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
              {{ $t('Edit') }}
            </b-button>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 border-right">
                <table v-if="commissions && commissions.length > 0" class="info-table table table-sm">
                  <tr>
                    <th class="border-top-0">{{ $t('Percentage') }}</th>
                    <th class="border-top-0" v-if="commissions.length > 1">{{ $t('Over') }}</th>
                  </tr>
                  <tr v-for="(commission, index) in commissions" :key="index">
                    <td>{{ commission.percent }} %</td>
                    <td v-if="commissions.length > 1">{{ (commission.amount_over || 0) | asCurrency }}</td>
                  </tr>
                </table>
                <no-data-available v-else :height="5"/>
              </div>
              <div class="col-md-6">
                <table class="info-table table mb-0 table-sm">
                  <tr>
                    <td class="border-top-0 font-weight-bold">{{ $t('Minimum commission') }}</td>
                    <td class="border-top-0">{{ inventory.minimum_commission | asCurrency }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('L/D Warranty ') }}</td>
                    <td>{{ inventory.insurance_rate | asPercentage }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('Entry Fee') }}</td>
                    <td>{{ inventory.lot_handling_charge | asCurrency }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('Rebate') }}</td>
                    <td>{{ inventory.rebate_rate | asPercentage }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="d-inline-block mb-0">
              {{ $t('Tax Rate') }}
            </h5>
            <b-button class="float-right p-0" variant="link" @click="onTaxRateUpdateClick">
              <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
              {{ $t('Edit') }}
            </b-button>
          </div>
          <div class="card-body">
            <span>{{ tax_rate }}</span>
          </div>
        </div>
      </div>
    </div>
    <commissions-modal/>
    <tax-rate-modal/>
  </div>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import helperService from "@/core/services/helper.service";
  import cloneDeep from "lodash/cloneDeep";
  import CommissionsModal from "@/modules/inventory/view/terms/modals/CommissionsModal";
  import inventory from "@/modules/inventory/Inventory.vue";
  import TaxRateModal from "@/modules/inventory/view/terms/modals/TaxRateModal.vue";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "Terms",
    components: {
      TaxRateModal,
      CommissionsModal,
      NoDataAvailable
    },
    methods: {
      ...mapActions(['showCommissionsModal', 'showTaxRateModal']),
      onTermsEditClick() {
        let commissionTierObject = this.inventory.commission_tiers
        if (commissionTierObject && !commissionTierObject.length > 0) {
          commissionTierObject = this.inventory.receipt.commissions
        }
        this.showCommissionsModal({
          inventory: this.inventory,
          object: {
            lot_handling_charge: this.inventory.lot_handling_charge,
            insurance_rate: this.inventory.insurance_rate,
            minimum_commission: this.inventory.minimum_commission,
            rebate_rate: this.inventory.rebate_rate,
            commissions: commissionTierObject,
          }
        })
      },
      onTaxRateUpdateClick() {
        this.showTaxRateModal({
          inventory: this.inventory,
          object: {
            tax_rate: this.inventory.tax_rate
          }
        })
      },
    },
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory,
      }),
      commissions() {
        if (this.inventory && this.inventory.commission_tiers) {
          let calculatedCommission = this.inventory.commission_tiers
          if (!calculatedCommission.length > 0) {
            calculatedCommission = this.inventory.receipt.commissions
          }
          let data = helperService.reverseCalculateTiers({commissions: cloneDeep(calculatedCommission)})
          return data.commissions
        }
        return []
      },
      tax_rate() {
        if (this.inventory) {
            return this.inventory.tax_rate
        }
        return null
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";
</style>

